<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0" v-if="!past">Current Competitions</h6>
          <h6 class="h2 text-white d-inline-block mb-0" v-else>Past Competitions</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="create" v-if="owner">New Competition</base-button>
          <base-button size="sm" type="neutral" @click="past = true" v-if="!past">Past Competitions</base-button>
          <base-button size="sm" type="neutral" @click="past = false" v-else>Current Competitions</base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <loading-panel v-if="loading"></loading-panel>
      <div v-else>
        <div v-if="scoreboards.length > 0">
          <b-row>
            <scoreboard v-for="(competition, index) in competitions" :key="index" :competition="competition" :scoreboard="scoreboards[index]" :size="'4'" :owner="owner"></scoreboard>
          </b-row>
        </div>
        <div v-else>
          <b-card no-body>
            <b-card-body>
              <h3 class="text-center text-danger" v-if="!past">You do not have any competitions currently.</h3>
              <h3 class="text-center text-danger" v-else>You do not have any past competitions.</h3>
            </b-card-body>
          </b-card>
        </div>
        <div v-if="teams">
          <h3>Joinable Team Competitions</h3>
          <b-row>
            <b-col md="4" v-for="team in teams" :key="team.id">
              <b-card no-body>
                <b-card-header>
                  <h3 class="mb-0 d-flex"><i class="fas text-gold fa-trophy fa-2x"></i> <span class="ml-3 mt-1">{{ team.name }}</span></h3>
                </b-card-header>
                <b-card-body>
                  <h4>{{ team.start_date }} - {{ team.end_date }}</h4>
                  <h5 v-if="team.source">Tracking Source: {{ team.source.name }}</h5>
                  <h5 v-else>Tracking Source: {{ team.based_on | capitalize }}</h5>
                  <div v-html="team.description"></div>
                </b-card-body>
                <b-card-footer>
                  <div class="text-center">
                    <b-button variant="danger" @click="join(team.id)">Join Competition</b-button>
                  </div>
                </b-card-footer>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <div v-if="communities">
          <h3>Joinable Community Competitions</h3>
          <b-row>
            <b-col md="4" v-for="community in communities" :key="community.id">
              <b-card no-body>
                <b-card-header>
                  <h3 class="mb-0 d-flex"><i class="fas text-gold fa-trophy fa-2x"></i> <span class="ml-3 mt-1">{{ community.name }}</span></h3>
                </b-card-header>
                <b-card-body>
                  <h4>{{ community.start_date }} - {{ community.end_date }}</h4>
                  <h5 v-if="community.source">Tracking Source: {{ community.source.name }}</h5>
                  <div v-html="community.description"></div>
                </b-card-body>
                <b-card-footer>
                  <div class="text-center">
                    <b-button variant="danger" @click="join(community.id)">Join Competition</b-button>
                  </div>
                </b-card-footer>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import LoadingPanel from '@/components/LoadingPanel';
import Scoreboard from './Scoreboard';

export default {
  components: {
    RouteBreadCrumb,
    LoadingPanel,
    Scoreboard
  },
  data() {
    return {
      competitions: [],
      pastCompetitions: [],
      scoreboards: [],
      pastScoreboards: [],
      loading: true,
      teams: null,
      communities: null,
      past: false,
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      roles: 'roles/roles'
    }),
    owner() {
      return this.roles.includes("owner");
    }
  },
  methods: {
    async getCreatedCompetitions() {
      await axios.get(this.userRoute + "/competitions/created")
      .then(response => {
        this.competitions = response.data;
        this.getScoreboards();
      })
      .catch(error => {
        // 
      });
    },
    async getPastCreatedCompetitions() {
      await axios.get(this.userRoute + "/competitions/created")
      .then(response => {
        this.competitions = response.data;
        this.getPastScoreboards();
      })
      .catch(error => {
        // 
      });
    },
    async getCompetitions() {
      await axios.get(this.userRoute + "/competitions")
      .then(response => {
        this.competitions = response.data;
        this.getCompetitorScoreboards();
      })
      .catch(error => {
        // 
      });
    },
    async getPastCompetitions() {
      await axios.get(this.userRoute + "/competitions/past")
      .then(response => {
        this.competitions = response.data;
        this.getPastCompetitorScoreboards();
      })
      .catch(error => {
        // 
      });
    },
    create() {
      this.$router.push('/competitions/create');
    },
    async getScoreboards() {
      await axios.get(this.userRoute + "/scoreboards")
      .then(response => {
        this.scoreboards = response.data;
        this.loading = false;
      })
      .then(error => {
        // 
      });
    },
    async getPastScoreboards() {
      await axios.get(this.userRoute + "/scoreboards/past")
      .then(response => {
        this.scoreboards = response.data;
        this.loading = false;
      })
      .then(error => {
        // 
      });
    },
    async getCompetitorScoreboards() {
      await axios.get(this.userRoute + "/competitor-scoreboards")
      .then(response => {
        this.scoreboards = response.data;
        this.loading = false;
      })
      .then(error => {
        // 
      });
    },
    async getPastCompetitorScoreboards() {
      await axios.get(this.userRoute + "/competitor-scoreboards/past")
      .then(response => {
        this.scoreboards = response.data;
        this.loading = false;
      })
      .then(error => {
        // 
      });
    },
    async getTeamCompetitions() {
      await axios.get(this.userRoute + "/competitions/team")
      .then(response => {
        this.teams = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async getCommunityCompetitions() {
      await axios.get(this.userRoute + "/competitions/community")
      .then(response => {
        this.communities = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async join(competition) {
      await axios.post(this.userRoute + "/competitions/" + competition + "/join")
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          if (this.owner) {
            this.getCreatedCompetitions();
            this.getScoreboards();
          } else {
            this.getCompetitions();
            this.getCompetitorScoreboards();
          }
          
          this.getTeamCompetitions();
          this.getCommunityCompetitions();
        });
      })
      .catch(error => {
        // 
      });
    }
  },
  mounted() {
    document.title = 'Competitions | ClarityNOW';
  },
  created() {
    if (this.owner) {
      this.getCreatedCompetitions();
    } else {
      this.getCompetitions();
    }

    this.getTeamCompetitions();
    this.getCommunityCompetitions();
  },
  watch: {
    past(to, from) {
      if (to) {
        if (this.owner) {
          this.getPastCreatedCompetitions();
        } else {
          this.getPastCompetitions();
        }
      } else {
        if (this.owner) {
          this.getCreatedCompetitions();
        } else {
          this.getCompetitions();
        }
      }
    }
  }
};
</script>